import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { TokenService } from "./Services/token.service";
import { isSiteAdminUser } from "./shared/site-admin.util";

/** Site Admin Dashboard — only Customer.UserRole Admin or Super Admin. */
@Injectable({
  providedIn: "root",
})
export class AdminGuard implements CanActivate {
  constructor(private tokenService: TokenService, private router: Router) {}

  canActivate(
    _next: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): boolean {
    if (!this.tokenService.hasUsableToken()) {
      this.router.navigate(["/login"]);
      return false;
    }

    let user: any = null;
    try {
      user = JSON.parse(localStorage.getItem("LoggedInUser") || "null");
    } catch {
      user = null;
    }

    if (!isSiteAdminUser(user)) {
      this.router.navigate(["/"]);
      return false;
    }
    return true;
  }
}
